import * as partten from "./partten.js";
export { partten };



//////////////////
// WEBPACK FOOTER
// ./partten/index.js
// module id = null
// module chunks = 